<template>
  <div class="partner">
    <div class="container">
      <div class="about-title">
        <h1 class="primary-title">嗨喵合伙人</h1>
        <h2 class="secondary-title">Joymew Partner</h2>
      </div>
      <div class="about-content">
        <div class="about-item-content">
          <div class="about-item-title">什么是嗨喵合伙人</div>
          <div class="about-item-body">
            <p>
              嗨喵合伙人是嗨喵悦动产品下最高级别用户，除了有特殊权利，还享受最高级别的收益和分成，一次付出终身收益。
            </p>
          </div>
        </div>
        <div class="about-item-content">
          <div class="about-item-title">我们可以帮您解决</div>
          <div class="about-item-body">
            <p>品牌IP打造</p>
            <p>强势引流</p>
            <p>激活裂变</p>
            <p>团队培训</p>
            <p>高效成交</p>
            <p>收益翻倍</p>
          </div>
        </div>
        <div class="about-item-content">
          <div class="about-item-title">6大理由选择嗨喵合伙人</div>
          <div class="about-item-body">
            <p>平台稳定</p>
            <p>优质资源</p>
            <p>优质服务</p>
            <p>根正苗红</p>
            <p>祝您实现梦想</p>
            <p>享零门槛收益</p>
          </div>
        </div>
        <div class="about-item-content">
          <div class="about-item-title">详情洽谈</div>
          <div class="about-item-body">
            <p>热线电话：400-082-2298</p>
            <p>电话/微信：19512368757</p>
          </div>
        </div>
      </div>
    </div>
    <myFooter />
  </div>
</template>

<script>
import myFooter from '@/components/myFooter.vue';

export default {
  name: 'partner',
  metaInfo: {
    title: '嗨喵悦动 - 嗨喵悦动登录_嗨喵悦动大屏互动',
    meta: [
      {
        name: 'keywords',
        content:
          '嗨喵悦动,嗨喵悦动大屏互动,嗨喵悦动官网,嗨喵悦动登录,微信墙,微信互动,现场互动,嗨现场',
      },
      {
        name: 'description',
        content:
          '嗨喵悦动是一款免费便捷炫酷的活动大屏幕现场互动软件，适用于企业年会、酒吧、婚礼、商业庆典峰会等活动现场，包括微信上墙送祝福、扫码签到、抽奖投票、摇一摇红包雨等有趣的大屏互动游戏，让活动更精彩！',
      },
    ],
  },
  components: { myFooter },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.banner {
  width: 100%;
  position: relative;
}
.banner > .img {
  width: 100%;
  height: 50%;
  background-color: #f9f9f9;
  vertical-align: middle;
  border: 0;
}

.about-title {
  top: 15%;
  padding: 20px 50px;
  width: 100%;
  color: #000;
  position: relative;
}

.primary-title {
  font-size: 40px;
}

.secondary-title {
  margin-top: 10px;
  padding-left: 30px;
  font-size: 20px;
  font-weight: 500;
  font-family: "Times New Roman", serif;
}

.container {
  position: relative;
}

.about-content {
  margin: 0px auto 0;
  padding: 30px 50px;
  width: 100%;
  max-width: 1090px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 20px 15px -5px #d3cfc5;
}

.about-item-content {
  margin-top: 10px;
}

.about-item-title {
  color: #ff4141;
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: bolder;
}

.about-item-body {
  margin-bottom: 30px;
  line-height: 1.5;
  text-indent: 2em;
}

p {
  margin: 0 0 10px;
}
</style>
